import { Skeleton } from '@chakra-ui/react';

import { PaperWithShadow } from 'uiToolkitV1/Paper';

export const NotificationLoading = () => (
  <>
    <PaperWithShadow p={3}>
      <Skeleton height="60px" width="100%" mt={2} />
      <Skeleton height="60px" width="100%" mt={2} />
      <Skeleton height="60px" width="100%" mt={2} />
    </PaperWithShadow>
    <PaperWithShadow p={3} mt={3}>
      <Skeleton height="44px" width="100%" mt={2} />
      <Skeleton height="44px" width="100%" mt={2} />
      <Skeleton height="44px" width="100%" mt={2} />
      <Skeleton height="44px" width="100%" mt={2} />
      <Skeleton height="44px" width="100%" mt={2} />
      <Skeleton height="44px" width="100%" mt={2} />
      <Skeleton height="44px" width="100%" mt={2} />
    </PaperWithShadow>
    <PaperWithShadow padding="12px" margin="12px 0">
      <Skeleton height="64px" width="100%" />
    </PaperWithShadow>
  </>
);
